import './scss/_notifications.scss'
import {NotificationListComponent} from './components/NotificationListComponent'
import {NotificationComponent} from './components/NotificationComponent'

const NotificationPackage = {
    name: 'notification',
    configure: function(config) {
        config.addComponent('notification-list', NotificationListComponent)
        config.addComponent('notification', NotificationComponent)
    }
}

export {NotificationPackage}
